// app/javascript/v2/containers/health-history-form/sections/MedicalIssues.jsx
import React from 'react'
import CheckboxField from '@/v2/components/common/CheckboxField'
import { MEDICAL_ISSUES } from '../constants'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  InfoBox,
} from '../styles'

const MedicalIssues = ({
  values,
  setValue,
  medicalIssues = MEDICAL_ISSUES,
}) => {
  const selected = values.medical_issues || []

  const toggle = value => {
    setValue(
      'medical_issues',
      selected.includes(value)
        ? selected.filter(v => v !== value)
        : [...selected, value]
    )
  }

  return (
    <StepCard>
      <TitleContainer>
        <StepIndicator>6</StepIndicator>
        <SectionTitle>Medical Issues</SectionTitle>
      </TitleContainer>
      <InfoBox>Check any conditions that apply to you.</InfoBox>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 4,
        }}
      >
        {medicalIssues.map(({ value, label }) => (
          <CheckboxField
            key={value}
            label={label}
            checked={selected.includes(value)}
            onChange={() => toggle(value)}
          />
        ))}
      </div>
    </StepCard>
  )
}

export default MedicalIssues
